export const Products = ["FWSED"];
export const ScopedProducts = [...Products, "PLATFORM"];
